import { render, staticRenderFns } from "./StatusList.vue?vue&type=template&id=ed5e6296&scoped=true"
import script from "./StatusList.vue?vue&type=script&lang=js"
export * from "./StatusList.vue?vue&type=script&lang=js"
import style0 from "./StatusList.vue?vue&type=style&index=0&id=ed5e6296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5e6296",
  null
  
)

export default component.exports